// Detecting virtual keyboards by observing average keypress duration:
// https://lyosha.me/blog/2016/02/12/detecting-virtual-keyboards/
export class VirtualKeyboardDetector {
	private nKeyPresses = 0;
	private totalDuration = 0;

	private lastKeyDownTime?: number;

	onKeyDown = () => {
		this.lastKeyDownTime = Date.now();
	};

	onKeyUp = () => {
		if (!this.lastKeyDownTime) {
			return;
		}
		this.totalDuration += Date.now() - this.lastKeyDownTime;
		this.nKeyPresses += 1;
	};

	get averageKeyPressDuration() {
		return this.totalDuration / this.nKeyPresses;
	}

	isVirtualKeyboard() {
		return this.averageKeyPressDuration < 25;
	}
}
